import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { AffiliationRole } from "../affiliations.types";

export type UseFetchAffiliationRolesResult = {
  roles: AffiliationRole[];
  isLoading: boolean;
  error: Error | null;
};

/**
 * Fetch available affiliation roles for select options.
 */
export function useFetchAffiliationRoles(): UseFetchAffiliationRolesResult {
  const { data, isLoading, error } = useQuery<AffiliationRole[]>({
    queryKey: ["affiliationRoles"],
    queryFn: async () => {
      return apiRequest(
        "/affiliation/roles/",
        "GET"
      ) as Promise<AffiliationRole[]>;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - roles don't change often
  });

  return {
    roles: data ?? [],
    isLoading,
    error: error as Error | null,
  };
}
